class FileUtils {
    static UNIX_FILE_PATH_DIVIDER = '/';
    static WINDOWS_FILE_PATH_DIVIDER = '\\';
    static S3_FILE_PATH_STARTER = "s";
    
    static BYTE_TO_KILO_BYTE_CONVERTION_FACTOR = 1024;
    static BYTE_TO_MEGA_BYTE_CONVERTION_FACTOR = FileUtils.BYTE_TO_KILO_BYTE_CONVERTION_FACTOR * 1024;
    static BYTE_TO_GIGA_BYTE_CONVERTION_FACTOR = FileUtils.BYTE_TO_MEGA_BYTE_CONVERTION_FACTOR * 1024;

    static getFileName(filePath) {
        let pathSegments = null;

        if (filePath.startsWith(FileUtils.UNIX_FILE_PATH_DIVIDER) || filePath.startsWith(FileUtils.S3_FILE_PATH_STARTER)) {
            pathSegments = filePath.split(FileUtils.UNIX_FILE_PATH_DIVIDER);
        } else {
            pathSegments = filePath.split(FileUtils.WINDOWS_FILE_PATH_DIVIDER);
        }
        return pathSegments[pathSegments.length - 1];
    }

    static getHumanReadableSize(size) {
        let humanReadableSize = null;
        if (size < FileUtils.BYTE_TO_KILO_BYTE_CONVERTION_FACTOR) {
            humanReadableSize = `${size} B`;
        } else if (size < FileUtils.BYTE_TO_MEGA_BYTE_CONVERTION_FACTOR) {
            humanReadableSize = `${(size / FileUtils.BYTE_TO_KILO_BYTE_CONVERTION_FACTOR).toFixed(2)} KB`;
        } else if (size < FileUtils.BYTE_TO_GIGA_BYTE_CONVERTION_FACTOR) {
            humanReadableSize = `${(size / FileUtils.BYTE_TO_MEGA_BYTE_CONVERTION_FACTOR).toFixed(2)} MB`;
        } else {
            humanReadableSize = `${(size / FileUtils.BYTE_TO_GIGA_BYTE_CONVERTION_FACTOR).toFixed(2)} KB`;
        }

        return humanReadableSize;
    }
}

export default FileUtils;